import ActionTextIcon from "@/components/icons/ActionTextIcon";
import Ellipsis from "@/components/views/Ellipsis";
import { tableStandardProps } from "@/utils/componentUtils";
import { Switch, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useTranslation } from "react-i18next";
import { generatePath, useSearchParams } from "react-router";
import { useListCalsSettings, useUpdateCalcSettings } from "../../../../common/api/queries/calcSettings";
import { CalcType } from "../../enums";
import { ADMIN_CALC_ROUTE_PATHS } from "../paths";
import { CalcSettings } from "../types";
import { convertCalcSettingsToUpdateObject } from "../utils";

export const CalcSettingsListView = () => {
  const { t } = useTranslation();

  const [urlParams] = useSearchParams();
  const calcType = urlParams.get("calcType") as CalcType | null;

  const { data } = useListCalsSettings({ calcType: calcType as CalcType });
  const updateCalcSettings = useUpdateCalcSettings();

  const columns: ColumnsType<CalcSettings> = [
    {
      key: "institution",
      title: t("calc.settings.attrs.institutionId"),
      width: 210,
      ellipsis: { showTitle: false },
      render: (_, record) => <Ellipsis>{record.institution.name}</Ellipsis>,
    },
    {
      key: "enabled",
      title: t("calc.settings.attrs.enabled"),
      align: "center",
      width: 100,
      render: (_, record) => (
        <Switch
          size="small"
          checked={record.enabled}
          onChange={() =>
            updateCalcSettings.mutate({
              id: record.id,
              object: convertCalcSettingsToUpdateObject({ ...record, enabled: !record.enabled }),
            })
          }
        />
      ),
    },
    {
      key: "actions",
      className: "right-align",
      width: 90,
      fixed: "right",
      render: (_, record) => (
        <ActionTextIcon
          path={generatePath(ADMIN_CALC_ROUTE_PATHS.detail.to, { id: record.id })}
          icon="edit"
          color="blue"
          text={t("common.edit")}
        />
      ),
    },
  ];

  return (
    <Table<CalcSettings>
      {...tableStandardProps()}
      columns={columns}
      scroll={{ x: 400 }}
      dataSource={data}
      pagination={false}
    />
  );
};
